module.exports = {
	"api": {
		"baseUrl": "https://easygestor-api-bb.fly.dev",
		"timeout": 8000,
		"retries": 5
	},
	"site": {
		"title": "EasyGestor",
		"description": "Sistema de Gestão Empresarial",
		"keywords": "gestão, empresarial, sistema, easygestor",
		"favicon": "/favicon.ico"
	},
	"features": {
		"debugMode": false,
		"mockData": false,
		"analytics": true
	},
	"theme": {
		"font": {
			"family": "Roboto Slab",
			"url": "https://fonts.googleapis.com/css2?family=Roboto+Slab:wght@100..900&family=Roboto:ital,wght@0,100..900;1,100..900&display=swap"
		},
		"colors": {
			"primary": "#056baa",
			"primaryVariant": "#044873",
			"secondary": "#12a3ff",
			"secondaryVariant": "#0f8cda",
			"light": "#ced6e0",
			"red": "#ef314a",
			"yellow": "#fcfc30",
			"darkBlue": "#056baa",
			"lightBlue": "#12a3ff",
			"lightBlue2": "#e6f4ff",
			"lightCyan": "#bdced5",
			"lightDark": "#889ba2",
			"dark": "#040f1f",
			"danger": "#e74c3c",
			"lightDanger": "#e74c3c",
			"info": "#3498db",
			"infoVariant": "#2980b9",
			"success": "#00d069",
			"successVariant": "#009149",
			"warn": "#ffdd59",
			"white": "#ffffff"
		},
		"text": {
			"letterSpacing": ".7px"
		},
		"button": {
			"borderRadius": "3px",
			"padding": "8px 20px;",
			"background": "#465eff",
			"color": "#fcfc30",
			"hoverBackground": "#044873",
			"hoverColor": "#ffffff",
			"letterSpacing": "0px"
		},
		"navbar": {
			"width": "240px",
			"backgroundColor": "#3d5aff",
			"hoverColor": "#fcfc30",
			"header": {
				"height": "60px",
				"backgroundColor": "#3d5aff"
			},
			"hover": {
				"backgroundColor": "#fcfc30",
				"textColor": "#4864fa"
			},
			"submenu": {
				"backgroundColor": "#12a3ff"
			},
			"active": {
				"backgroundColor": "#fcfc30",
				"textColor": "#4864fa"
			}
		}
	},
	"views": {
		"excludevViews": [
			""
		]
	},
	"menu": {
		"excludePaths": [
			""
		]
	},
	"login": {
		"maxAttempts": 5,
		"lockoutDuration": 15,
		"method": "sso",
		"logoutRedirect": "https://www.bb.com.br/site/",
		"brands": [
			"https://content.easygestor.com/wp-content/uploads/2025/09/logo_03.png",
			"https://content.easygestor.com/easygestor/logo_bb.png"
		],
		"redirect": "/"
	},
	"version": "1.0.0"
};


//////////////////
// WEBPACK FOOTER
// ./config/envs/bb/production.json
// module id = 616
// module chunks = 0